import { enums } from "@shared/constants";

export const EVENT_WIZARD_SCREENS_MAP = {
  CALENDAR: {
    id: "CALENDAR",
    trackingLabel: enums.INTERACTION_LABEL_MAP.EVENT_CALENDAR.id,
  },
  TICKET_TYPE_SELECTION: {
    id: "TICKET_TYPE_SELECTION",
    trackingLabel:
      enums.INTERACTION_LABEL_MAP.EVENT_CALENDAR_TICKET_TYPE_SELECTION.id,
  },
  TICKET_QUANTITY_PROMPT: {
    id: "TICKET_QUANTITY_PROMPT",
    trackingLabel:
      enums.INTERACTION_LABEL_MAP.EVENT_CALENDAR_QUANTITY_PROMPT.id,
  },
};
